exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".integrations-form-layout {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n  margin: 0 3.5rem;\n}\n\n@media only screen and (min-width: 768px) {\n  .integrations-form-layout {\n    margin: 0 auto;\n    max-width: 90rem;\n  }\n}\n\n", ""]);

// exports
